<template>
  <div>
    <h1>Support</h1>

    <p>Get help to join an event and connect your device.</p>

    <h3>Knowledge Base</h3>
    <v-row class="card-grid">
      <v-col cols="12" sm="4">
        <BigButton 
          elevated 
          icon="fal fa-watch-fitness"
          icon-color="black"
          title="Device " 
          text="Tips and troubleshooting for connecting apps or wearables" 
          href="https://corporatefitness.helpscoutdocs.com/category/15-device-integrations"
          />
      </v-col>
      <v-col cols="12" sm="4">
        <BigButton 
          elevated 
          icon="fal fa-user"
          icon-color="black"
          title="For Participants" 
          text="All other topics for participants of events" 
          href="https://corporatefitness.helpscoutdocs.com/collection/4-app"
          />
      </v-col>
      <v-col cols="12" sm="4">
        <BigButton 
          elevated 
          icon="fal fa-tools"
          icon-color="black"
          title="For Event Admins" 
          text="Information for organizers of events" 
          href="https://corporatefitness.helpscoutdocs.com/collection/1-eventmanager"
          />
      </v-col>
    </v-row>

    <h3 class="mt-8">Submit a question</h3>
    <p>Reach out to our support team in case your question hasn't been answered using the resources above.</p>
    <p>Please note that this option might not be available to you, depending on the service plan selected by your organization.</p>
    <p><v-btn color="primary" class="" @click="openDialog">Submit a request</v-btn></p>

    <LoginOrRegisterDialog ref="loginForm" mode="LOGIN" message="In order to submit a support request, ou need to login with your account." />

    <multi-step-dialog title="Submit Support Request" :step="1" ref="supportDialog" formRefName="supportForm" single-step :show-confirm="supportStatus == 'OK'" @confirm="submit" confirm-label="Submit">
      <v-card-text v-if="supportStatus == 'ERROR'">
        <p>Please check the knowledge base articles first.</p>
        <p>If that doesn't help, please reach out to your event organizer directly at <a :href="`mailto:${supportEmail}`">{{supportEmail}}</a>. They can best help you get connected.</p>
      </v-card-text>
      <v-card-text v-else>
        <p><strong>Please email directly to the organization hosting your event for faster response times!</strong></p>
        <p>Alternatively, leave a message using form below and we'll get back to you. Please make sure to enter all fields so we can help you more efficiently.</p>

        <v-form lazy-validation ref="supportForm" action="https://formspree.io/f/xgeqqwlq" method="POST">

          <v-text-field
            v-model="name"
            :rules="nameRules"
            label="Your Name"
            name="name"
            required
          ></v-text-field>

          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            name="email"
            type="email"
            required
          ></v-text-field>

          <v-textarea 
            v-model="comments" 
            required 
            label="Your question:" 
            name="comments" 
            :rules="msgRules"
            persistent-hint 
            hint="Please include as many details as possible."
            />
          
          <input type="hidden" name="timezone" :value="timeZoneOlson"/>
          <input type="hidden" name="mode" value="Support Form"/>
          <input type="hidden" name="profileID" :value="profileId"/>
          <input type="hidden" name="eventID" :value="eventId"/>
          <input type="hidden" name="tenant" :value="tenant.name"/>

          <!-- <v-btn class="primary" type="submit" x-large>Submit</v-btn> -->
        </v-form> 
      </v-card-text>
    </multi-step-dialog>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { EventBus } from '@/plugins/eventbus.js';
import { DateTime } from 'luxon'
import BigButton from "@/components/BigButton";
import LoginOrRegisterDialog from '@/components/LoginOrRegisterDialog.vue';
import MultiStepDialog from "@/components/generic/MultiStepDialog.vue";
import profileService from "@/services/profileService";
import tenants from '@/data/tenants.config'
const tenant = tenants.current();

export default {
  name: "StartTrial",
  components: {
    BigButton,
    LoginOrRegisterDialog,
    MultiStepDialog,
  },
  props: {
  },
  data: function() {
    return {
      tenant: tenant,
      valid: true,
      showLoginDialog: false,
      timeZoneOlson: null,
      org: '',
      supportStatus: null,
      eventId: '',
      profileId: '',
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
      ],
      orgRules: [
        v => !!v || 'Please enter the name of your organization',
      ],
      msgRules: [
        v => (!!v && v.length > 10) || 'Please describe the issue you are facing in more details',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      comments: '',
    };
  },
  created() {
  },
  mounted() {
    this.timeZoneOlson = DateTime.now().zoneName;
    
    EventBus.$on('login-state-change', async user => {
      if (this.showLoginDialog && user) {
        // logged in during the process, now start trial
        this.openDialog();
      }
    });
  },
  methods: {
    async openDialog() {
      if (this.user) {
        var context = (await profileService.getSupportContext()).data;
        this.profileId = context.profile_id;
        this.eventId = context.event && context.event.id;
        this.orgId = context.org && context.org.id;
        this.supportEmail = context.support_email;
        this.supportStatus = context.status;
        this.$refs.supportDialog.open();
      }
      else {
        this.showLoginDialog = true;
        this.$refs.loginForm.open();
      }
    },    
    async submit() {
      console.log('/// submit???');
      var form = this.$refs.supportForm;
      form.submit();
    }
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },
  watch: {
  }
};
</script>

<style  lang="scss">
</style>